<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'اولياء الامور'" :to="{name: 'parents'}">اولياء الامور</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'parents.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                               <i class="flaticon-computer-4"></i>
                                            معلومات ولى الامر</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                         <div class="row">
                                  <div class="col-md-4">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                        <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                              {{ getErrors['name'][0] }}
                                        </div>
                                    </div>
                                        </div>

                                   <div class="col-md-4">
                                           <label for="exampleFormControlInput1">رقم الجوال</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                        <input type="test" class="form-control" id="exampleFormControlInput1" v-model="data.form.mobile" placeholder="رقم الجوال">
                                        <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"   v-if="getErrors['mobile']">
                                              {{ getErrors['mobile'][0] }}
                                        </div>
                                    </div>
                                       </div>
                                    <div class="col-md-4">
                                            <label for="exampleFormControlInput3">كلمة المرور</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="password" class="form-control" id="exampleFormControlInput3" v-model="data.form.password" placeholder="*******">
                                        <div class="invalid-feedback" :style="getErrors['password'] ? 'display: block' : 'display: none;'"   v-if="getErrors['password']">
                                              {{ getErrors['password'][0] }}
                                        </div>
                                    </div>
                                     </div>

                                     <div class="form-group col-md-4 mb-4">
                                        <label for="exampleFormControlSelect1">المرحلة الدراسية</label>
                                        <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroupsByStage" :multiple="false"/>

                                        <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                              {{ getErrors['stage_id'][0] }}
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4 mb-4">
                                        <label for="exampleFormControlSelect1">الصف</label>
                                        <treeselect :options="groups" v-model="data.form.group_id"  @select="setStage" :multiple="false"/>

                                        <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                              {{ getErrors['group_id'][0] }}
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4 mb-4">
                                        <label for="exampleFormControlInput12">تاريخ الطلب</label>
                                        <date-picker v-model="data.form.request_date"  :editable="true" :calendar="'hijri'"></date-picker>
                                        <div class="invalid-feedback" :style="getErrors['request_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['request_date']">
                                            {{ getErrors['request_date'][0] }}
                                        </div>
                                    </div>
                                     <div class="form-group col-md-4 mb-4">
                                      <label for="">حالة الطلب</label>
                                      <select class="form-control" v-model="data.form.status">
                                        <option value="pending">معلق</option>
                                        <option value="canceled">مرفوض</option>
                                        <option value="accepted">مقبول</option>
                                      </select>
                                    </div>
                                        </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'parents'}">
                                      <span>رجوع</span>
                                    </router-link>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      groups: [],
      stages: [],
      data: {
        checker: false,
        form:{
            name: '',
            mobile: '',
            password: '',
            group_id: '',
            stage_id: '',
            request_date: '',
            status: 'pending'
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      this.getRequirements();
  },
  methods: {
       resetForm(){
        this.data.form = {
            name: '',
            mobile: '',
            password: '',
            group_id: '',
            stage_id: '',
            request_date: '',
            status: 'pending'
        };
    },
      getInfo(){
        this.$baseApi.get('/parents/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
                this.data.form = response.data.data.parent;
                this.stages = response.data.data.stages;
                this.groups = response.data.data.groups;

            }else if(response.data.code == 404){
                router.push('/parents');
            }else{
                alert(response.data.data.error);
                router.push('/parents');
            }
        });
      },
      update(){
          this.data.isRequested = true;
        this.$baseApi.patch('/parents/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية التعديل');
              this.sweetAlert(response.data.messages[0])
                router.push('/parents');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getInfo();
      },
      getGroupsByStage(val){
        this.data.form.group_id = '';
        this.$baseApi.get('/parents/' + this.$route.params.id + '/edit?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      setStage(val){
        this.$baseApi.get('/parents/' + this.$route.params.id + '/edit?option=stage&s='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.data.form.stage_id = response.data.data.stage.id;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  }
};
</script>
<style>
</style>
